import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-309"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.315 2.086a3.146 3.146 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.146 3.146 0 0 0-.396-.04 3.184 3.184 0 1 0 1.243 6.116 4.61 4.61 0 0 0 6.144 0 3.185 3.185 0 1 0 1.243-6.116zm0 5.369a2.17 2.17 0 0 1-.852-.173 1 1 0 0 0-1.05.167 3.61 3.61 0 0 1-4.827 0 1 1 0 0 0-1.049-.167 2.185 2.185 0 1 1-.852-4.196 1.237 1.237 0 0 1 .17.018l.101.014a1 1 0 0 0 .962-.444 3.675 3.675 0 0 1 6.164 0 1 1 0 0 0 .962.444l.102-.014a1.237 1.237 0 0 1 .17-.018 2.184 2.184 0 1 1 0 4.369zm-4.211 2.838a.255.255 0 0 0-.325.14l-.966 2.423a.251.251 0 0 0 .14.326.256.256 0 0 0 .093.017.25.25 0 0 0 .232-.157l.966-2.423a.251.251 0 0 0-.14-.326zm-3.728.207a.248.248 0 0 0-.325.137l-.71 1.747a.25.25 0 0 0 .138.325.243.243 0 0 0 .093.019.25.25 0 0 0 .232-.156l.71-1.746a.25.25 0 0 0-.138-.326zm7.247.1a.248.248 0 0 0-.325.136l-.71 1.747a.25.25 0 0 0 .137.326.243.243 0 0 0 .094.018.25.25 0 0 0 .232-.156l.71-1.746a.25.25 0 0 0-.138-.326z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }